import {Component,OnInit} from '@angular/core';
import {ActivatedRoute,ParamMap,Router} from '@angular/router';
import {ITEMS_PER_PAGE} from 'src/app/shared/constants/pagination.constants';

import {HttpErrorResponse,HttpHeaders,HttpResponse} from '@angular/common/http';
import {JhiAlertService,JhiEventManager} from 'ng-jhipster';
import {Subscription} from 'rxjs';
import {Principal,StateStorageService} from 'src/app/core';
import {BulkDeclarationService} from '../bulk-declaration/bulk-declaration.service';
import { LanguageChangeService } from 'src/app/shared/services/language-change.service';

@Component({
  selector: 'jhi-scope-my-declarations',
  templateUrl: './scope-my-declarations.component.html',
  styleUrls: []
})
export class ScopeMyDeclarationsComponent implements OnInit {

  error: any;
  success: any;
  eventSubscriber: Subscription;
  routeData: any;
  links: any;
  totalItems: any;
  queryCount: any;
  itemsPerPage: any;
  page: any;
  predicate: any;
  previousPage: any;
  reverse: any;
  searchText: string;
  flag: boolean;
  currentAccount: any;
  rulesRequest = [];
  pid: any;
  sid: any;

  constructor(
    private bulkDeclarationService: BulkDeclarationService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private jhiAlertService: JhiAlertService,
    public principal: Principal,
    private eventManager: JhiEventManager,
    private stateStorageService: StateStorageService,
    private languageChangeService: LanguageChangeService,

  ) {
    this.itemsPerPage = ITEMS_PER_PAGE;
    this.page = 1;
    this.predicate = 'id';
         this.activatedRoute.queryParamMap.subscribe((paramMap: ParamMap) => {
            const refresh = paramMap.get('refresh');
            if (refresh) {
                 
                this.languageChangeService.refreshLanguage();
            }
    });
  }
// do changes here
  previousState() {
    // window.history.back();
    this.router.navigateByUrl("/scope-my-suffix/"+this.sid+"/view")
  }

  backOnPrevious(){
    this.router.navigateByUrl("/scope-my-suffix/"+this.sid+"/view")
  }
  
  ngOnInit() {

    this.activatedRoute.params.subscribe(event => {
      this.pid = event.pid ? event.pid : null;
      this.sid = event.sid ? event.sid : null;
    });


    this.principal.identity().then(account => {
      this.currentAccount = account;
    });

    this.registerChangeInManualRequest();

    if (this.pid && this.sid) {
      this.loadAll();
    }
  }


  ngOnDestroy() {
    if (this.eventSubscriber) 
    this.eventManager.destroy(this.eventSubscriber);
  }

  trackId(index: number, item: any) {
    return item.id;
  }

  registerChangeInManualRequest() {
    this.eventSubscriber = this.eventManager.subscribe('BulkScopeListModification', response => this.loadAll());
  }

  sort() {
    const result = [this.predicate + ',' + (this.reverse ? 'asc' : 'desc')];
    if (this.predicate !== 'id') {
      result.push('id');
    }
    return result;
  }

  private paginateManualRequests(data: any[], headers: HttpHeaders) {
    this.totalItems = parseInt(headers.get('X-Total-Count'), 10);
    this.queryCount = this.totalItems;
    this.rulesRequest = data;
  }

  private onError(errorMessage: string) {
    this.jhiAlertService.error(errorMessage, null, null);
  }

  loadAll() {
    this.bulkDeclarationService
      .queryWithUrl('/policy/' + this.pid + '/scope/' + this.sid, {
        page: this.page - 1,
        size: this.itemsPerPage,
        sort: this.sort()
      })
      .subscribe(
        (res: HttpResponse<any[]>) => this.paginateManualRequests(res.body, res.headers),
        (res: HttpErrorResponse) => this.onError(res.message)
      );
  }

  loadPage(page: number) {
    if (page !== this.previousPage) {
      this.previousPage = page;
      this.transition();
    }
  }

  transition() {
    if (this.searchText) {
      this.searchItems();
      this.flag = true;
    } else {
      this.router.navigate(['/scope-my-suffix/scope-my-declarations/' + this.pid + '/' + this.sid], {
        queryParams: {
          page: this.page,
          size: this.itemsPerPage,
          sort: this.predicate + ',' + (this.reverse ? 'asc' : 'desc')
        }
      });
      this.loadAll();
    }
  }

  clear() {
    this.page = 0;
    this.router.navigate([
      '/scope-my-declarations/' + this.pid + '/' + this.sid,
      {
        page: this.page,
        sort: this.predicate + ',' + (this.reverse ? 'asc' : 'desc')
      }
    ]);
    this.loadAll();
  }

  searchItems() {
    if (this.searchText) {
      var pNo = 0;
       var size = this.itemsPerPage;
      if (this.flag == true) {
        pNo = this.page - 1;
        size = this.itemsPerPage;
        this.flag = false;
      }
      this.principal
        .searchQuery(this.searchText, 'bulk-certificate-requests/policy/' + this.pid + '/scope/' + this.sid + '/search', {
          page: pNo,
          size: size,
          sort: this.sort()
        })
        .subscribe(
          (res: HttpResponse<any[]>) => this.paginateManualRequests(res.body, res.headers),
          (res: HttpErrorResponse) => this.onError(res.message)
        );
    } else {
      this.loadAll();
    }
  }

  onChange(value) {
    this.page = 0;
    this.itemsPerPage = value
    this.loadAll();
  }

}
